export default "__VITE_PUBLIC_ASSET__1a437f5b__"